// import React, { useEffect, useState } from "react";

// export default function GroupKnowledgeSessionTab({ resourcesDetails }) {
//   const [sessions, setSessions] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (resourcesDetails?.KnowledgeSessions) {
//       setSessions(resourcesDetails.KnowledgeSessions);
//     } else {
//       setSessions([]);
//     }
//     setLoading(false);
//   }, [resourcesDetails]);

//   console.log(sessions, ">>>>>sessions in gks tab");
//   console.log(resourcesDetails, ">>>>resourcesDetails in gks tab ");

//   return (
//     <div className="p-4">
//       {loading ? (
//         <p className="text-gray-500">Loading sessions...</p>
//       ) : sessions.length === 0 ? (
//         <p>No sessions available.</p>
//       ) : (
//         <div className="overflow-auto">
//           <table className="min-w-full border border-gray-300 text-sm">
//             <thead className="bg-purple-100">
//               <tr>
//                 {/* <th className="border p-2">ID</th> */}
//                 <th className="border p-2">Display Name</th>
//                 <th className="border p-2">Category</th>
//                 <th className="border p-2">Sector</th>
//                 {/* <th className="border p-2">Created</th> */}
//                 {/* <th className="border p-2">Delivered</th> */}
//                 <th className="border p-2">Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {sessions.map((session) => (
//                 <tr key={session.id} className="hover:bg-gray-50">
//                   {/* <td className="border p-2 text-center">{session.id}</td> */}
//                   <td className="border p-2">{session.sResourceDisplayName}</td>
//                   <td className="border p-2">{session.sCategory || "—"}</td>
//                   <td className="border p-2">{session.sBusinessSector}</td>
//                   {/* <td className="border p-2">
//                     {new Date(session.dtCreated).toLocaleDateString()}
//                   </td> */}
//                   {/* <td className="border p-2">
//                     {session.dtDelivered
//                       ? new Date(session.dtDelivered).toLocaleDateString()
//                       : "—"}
//                   </td> */}
//                   <td className="border p-2">{session.refCurrentStateSPM}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }



// wITH PURPLE THEME TABLE-
import React, { useEffect, useState } from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, CircularProgress } from "@material-ui/core";
import {Button} from "../../common/Button/Button"

export default function GroupKnowledgeSessionTab({ resourcesDetails, addResourcesDetails, groupKnowledgeInstIdArr }) {
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (resourcesDetails?.KnowledgeSessions) {
            setSessions(resourcesDetails.KnowledgeSessions);
        } else {
            setSessions([]);
        }
        setLoading(false);
    }, [resourcesDetails]);

    console.log(sessions, ">>>>>sessions in gks tab");
    console.log(resourcesDetails, ">>>>resourcesDetails in gks tab ");

    return (
        <div className="p-1">
            {loading ? (
                <CircularProgress />
            ) : sessions.length === 0 ? (
                <p>No sessions available.</p>
            ) : (
                <div className="overflow-auto" style={{ maxHeight: "420px" }}>
                    <Table stickyHeader className="min-w-full">
                        <TableHead style={{ backgroundColor: "#7e1f9a" }}>
                            <TableRow>
                                <TableCell style={{ color: "purple" }}>Instance ID</TableCell>
                                <TableCell style={{ color: "purple" }}>Display Name</TableCell>
                                <TableCell style={{ color: "purple" }}>Category</TableCell>
                                <TableCell style={{ color: "purple" }}>Sector</TableCell>
                                <TableCell style={{ color: "purple" }}>Created</TableCell>
                                <TableCell style={{ color: "purple" }}>Delivered</TableCell>
                                <TableCell style={{ color: "purple" }}>Status</TableCell>
                                <TableCell style={{ color: "purple" }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sessions.map((session) => (
                                <TableRow key={session.id} hover>
                                    <TableCell>{session.nResourceInstanceId}</TableCell>
                                    <TableCell>{session.sResourceDisplayName}</TableCell>
                                    <TableCell>{session.sCategory || "—"}</TableCell>
                                    <TableCell>{session.sBusinessSector}</TableCell>
                                    <TableCell>
                                        {session.dtDelivered
                                            ? new Date(session.dtDelivered).toLocaleDateString()
                                            : "—"}
                                    </TableCell>
                                    <TableCell>
                                        {session.dtDelivered
                                            ? new Date(session.dtDelivered).toLocaleDateString()
                                            : "—"}
                                    </TableCell>
                                    <TableCell>{session.refCurrentStateSPM}</TableCell>
                                    <TableCell><Button onClick={()=>addResourcesDetails(0, session.nResourceInstanceId)}>Add Details</Button></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            )}
        </div>
    );
}
